import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/no-data.png'


const _withScopeId = n => (_pushScopeId("data-v-6ea2129f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-list-page" }
const _hoisted_2 = {
  key: 0,
  class: "post-list-content"
}
const _hoisted_3 = { class: "post-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "post-basic-info" }
const _hoisted_6 = { class: "df aic" }
const _hoisted_7 = { class: "post-name" }
const _hoisted_8 = {
  key: 0,
  class: "post-salary"
}
const _hoisted_9 = {
  key: 1,
  class: "post-salary"
}
const _hoisted_10 = {
  key: 2,
  class: "post-isUrgent"
}
const _hoisted_11 = { class: "df aic" }
const _hoisted_12 = { class: "other-info" }
const _hoisted_13 = { class: "post-basic-info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post-company-name" }, "已投递", -1))
const _hoisted_15 = { class: "post-address" }
const _hoisted_16 = { class: "pagination-block" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "no-data"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-data-info" }, "暂无投递记录", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("查看工作机会")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_load = _resolveDirective("load")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.totalPost > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (_ctx.toDetail(item)),
                class: _normalizeClass(["post-item df aic jcsb", { 'take-down': item.status !== 2 }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.postName), 1),
                    (item.salaryRangeText !== '面议')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.salaryRangeText) + "元/月", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "薪资面议")),
                    (item.isUrgent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "急聘"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.customerName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$utils.dateFm(item.createTime, "YYYY-MM-DD hh:mm")), 1)
                ])
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.currentPage,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageSize) = $event)),
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.totalPost,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_ctx.isInit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createVNode(_component_el_button, {
                  class: "submit-btn",
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toPostList()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
  ])), [
    [_directive_load, _ctx.isLoading]
  ])
}